import * as images from "@/components/images/Images";
import { ServicesHeroData } from "./types";
import { ROUTES } from "@/constants";

const servicesHeroStandard = {
  title: "Standard translation services",
  description:
    "Translate any type of content fast with the highest quality content translation service in 100+ languages for just $0.10 per word.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
  secondaryButton: {
    href: ROUTES.getQuote,
    label: "Get a quote",
  },
  imageUrl: images.servicesStandardHero,
  imageDimensions: {
    width: 1024,
    height: 1032,
  },
} as ServicesHeroData;

const servicesHeroCertified = {
  title: "Certified translations you can count on",
  description:
    "Have confidence our certified translation services will meet your official document translation needs for just $24.50 per page.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
  secondaryButton: {
    href: ROUTES.getQuote,
    label: "Get a quote",
  },
  imageUrl: images.servicesCertifiedHero,
  imageDimensions: {
    width: 1024,
    height: 1089,
  },
} as ServicesHeroData;

const servicesHeroEnterprise = {
  title: "Grow globally with Languex translation services for businesses",
  description:
    "Customize and manage high-quality enterprise translations quickly and at scale across 100+ languages.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
  secondaryButton: {
    href: ROUTES.getQuote,
    label: "Get a quote",
  },
  imageUrl: images.servicesEnterpriseHero,
  imageDimensions: {
    width: 1265,
    height: 1081,
  },
} as ServicesHeroData;

const servicesHeroNotarized = {
  title: "Fast and affordable notarized translations",
  description:
    "Get a notary certified translation quickly for an additional $19.95 per certified translation.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
  imageUrl: images.servicesNotarizedHero,
  imageDimensions: {
    width: 1204,
    height: 1032,
  },
} as ServicesHeroData;

const servicesHeroUrgent = {
    title: "High-quality urgent translations",
    description:
      "When every minute counts, select expedited service at checkout to get same day translation delivery in 12-24 hours or sooner across 100+ languages.",
    primaryButton: {
      href: ROUTES.startOrder,
      label: "Start order",
    },
    imageUrl: images.servicesUrgentHero,
    imageDimensions: {
      width: 1204,
      height: 1032,
    },
  } as ServicesHeroData;

export const servicesHeroMap = {
  standard: servicesHeroStandard,
  certified: servicesHeroCertified,
  enterprise: servicesHeroEnterprise,
  notarized: servicesHeroNotarized,
  urgent: servicesHeroUrgent,
};
